"use client"

import Script from "next/script"

interface ClarityProps {
  projectId: string
}

/**
 * Injects the Microsoft Clarity script for a given Project ID.
 * projectId is resolved server-side (layout.tsx + lib/pixel/clarity.ts) —
 * this component never makes an API call. Clarity captures sessions,
 * heatmaps, and AI insights automatically; smart events are configured in
 * the merchant's Clarity dashboard.
 */
export default function Clarity({ projectId }: ClarityProps) {
  return (
    <Script
      id="ms-clarity"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "${projectId}");
        `,
      }}
    />
  )
}
